// Source: taken from the monolith enum: https://github.com/Zocdoc/zocdoc_web/blob/master/PatientRecalls/ZocDoc.PatientRecalls/WellGuideRecommendations/RecommendationType.cs

export const WELLGUIDE_RECOMMENDATION_TYPES = {
    PHYSICAL_EXAM: 0,
    SKIN_SCREENING: 1,
    DENTAL_EXAM: 2,
    VISION_EXAM: 3,
    SIGN_UP_FOR_ZOCDOC: 4,
    SHARE_ZOCDOC: 5,
    WELL_WOMAN_EXAM: 6,
};
